module.exports = __webpack_public_path__ + "img/arrow_opened.839cb34d.svg";